import { AppUser, ListingStatus } from '../types';

/**
 * What a viewer gets on a listing's public page (plan 16, preview of unpublished pages):
 * - 'public': published, everyone sees it.
 * - 'preview': not published, but this viewer is the super admin or an owner,
 *   so they see the page as visitors will, with a "not published yet" banner.
 *   Owners don't preview a listing they deleted; the super admin previews any status.
 * - 'none': "not found" (the Firestore rules refuse the read anyway).
 */
export type PageAccess = 'public' | 'preview' | 'none';

export function pageAccess(
  listing: { status: ListingStatus; ownerUids?: string[] },
  viewer: Pick<AppUser, 'uid' | 'role'> | null | undefined
): PageAccess {
  if (listing.status === 'published') return 'public';
  if (!viewer) return 'none';
  if (viewer.role === 'superAdmin') return 'preview';
  if (listing.status !== 'deleted' && (listing.ownerUids ?? []).includes(viewer.uid)) return 'preview';
  return 'none';
}
